export default __webpack_public_path__ + "static/media/miguel-lopes-40.093d18cb.jpg";